export default {"src":"/_next/static/media/nectarines.a1f48da4.svg","height":677,"width":677,"blurWidth":0,"blurHeight":0};